var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoHayProyectos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1029 834",
    style: {
      enableBackground: "new 0 0 1029 834"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ECECEC;}\n\t.st1{fill:#F5F5F5;}\n\t.st2{fill:#F0F0F0;}\n\t.st3{fill:#A35805;}\n\t.st4{fill:#FF9200;}\n\t.st5{fill:#0C3149;}\n\t.st6{fill:#E20000;}\n\t.st7{fill:#12B212;}\n\t.st8{fill:#E1E1E1;}\n\t.st9{fill:#054205;}\n\t.st10{fill:#8E4B09;}\n\t.st11{fill:#5E3606;}\n\t.st12{opacity:0.5;fill:#383634;}\n\t.st13{fill:none;stroke:#1A2E35;stroke-width:0.7068;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st14{fill:#FCC1BB;}\n\t.st15{opacity:0.2;enable-background:new    ;}\n\t.st16{fill:#FD897B;}\n\t.st17{fill:#1A2E35;}\n\t.st18{opacity:0.2;}\n\t.st19{fill:#FFFFFF;}\n\t.st20{fill:#EB827E;}\n\t.st21{fill:#007CFF;}\n\t.st22{opacity:0.6;fill:#FFFFFF;}\n\t.st23{opacity:0.7;fill:#FFFFFF;}\n\t.st24{opacity:0.1;enable-background:new    ;}\n\t.st25{opacity:0.2;fill:#FFFFFF;}\n\t.st26{fill:none;stroke:#1A2E35;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st27{opacity:0.4;enable-background:new    ;}\n\t.st28{opacity:0.25;enable-background:new    ;}\n\t.st29{opacity:0.15;enable-background:new    ;}\n\t.st30{opacity:0.8;fill:#FFFFFF;}\n\t.st31{opacity:0.5;fill:#FFFFFF;}\n\t.st32{fill:none;stroke:#E20000;stroke-width:3;stroke-miterlimit:10;}\n\t.st33{fill:none;}\n\t.st34{fill:#EE9218;}\n\t.st35{fill:#EE931C;}\n\t.st36{fill:#824599;}\n\t.st37{fill:#057DAD;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 676.97,
    className: "st0",
    width: 966,
    height: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840.22,
    y: 708.07,
    className: "st0",
    width: 63.99,
    height: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.12,
    y: 713.31,
    className: "st0",
    width: 16.8,
    height: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    x: 801.2,
    y: 690.13,
    className: "st0",
    width: 37.08,
    height: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.35,
    y: 693.37,
    className: "st0",
    width: 83.45,
    height: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 693.37,
    className: "st0",
    width: 12.24,
    height: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 701.53,
    className: "st0",
    width: 180.98,
    height: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M492.91,590.81H119.84c-6.08,0-11.03-4.95-11.03-11.03V55.37c0-6.08,4.95-11.03,11.03-11.03h373.07 c6.08,0,11.03,4.95,11.03,11.03v524.41C503.94,585.86,498.99,590.81,492.91,590.81z M119.84,44.83 c-5.81,0-10.54,4.73-10.54,10.54v524.41c0,5.81,4.73,10.54,10.54,10.54h373.07c5.81,0,10.54-4.73,10.54-10.54V55.37 c0-5.81-4.73-10.54-10.54-10.54H119.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M910.8,590.81H537.73c-6.08,0-11.03-4.95-11.03-11.03V55.37c0-6.08,4.95-11.03,11.03-11.03H910.8 c6.08,0,11.03,4.95,11.03,11.03v524.41C921.82,585.86,916.88,590.81,910.8,590.81z M537.73,44.83 c-5.81,0-10.54,4.73-10.54,10.54v524.41c0,5.81,4.73,10.54,10.54,10.54H910.8c5.81,0,10.55-4.73,10.55-10.54V55.37 c0-5.81-4.73-10.54-10.55-10.54H537.73z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "729.86,265.52 822.66,265.52 821.23,252.98 728.44,252.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "736.5,324.17 829.3,324.17 827.88,311.63 735.08,311.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "743.15,382.82 835.94,382.82 834.52,370.27 741.72,370.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "749.79,441.47 842.59,441.47 841.17,428.92 748.37,428.92  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "768.34,677.08 782.87,677.08 731.99,228.02 717.46,228.02  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 592.38,
    y: 152.92,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1424.0751 319.6443)",
    className: "st2",
    width: 239.31,
    height: 13.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M636.35,115.35l-1.39-1.94c-0.51-0.71-1.32-1.14-2.17-1.14h-9.82c-0.85,0-1.61,0.43-2.04,1.14l-1.17,1.94 c-0.43,0.71-1.19,1.14-2.04,1.14h-5.86c-1.4,0-2.46,1.14-2.38,2.55l1.9,32.79c0.08,1.41,1.28,2.55,2.68,2.55h46.44 c1.4,0,2.46-1.14,2.38-2.55l-1.9-32.79c-0.08-1.41-1.28-2.55-2.68-2.55h-19.78C637.67,116.49,636.86,116.06,636.35,115.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M662.94,119.61h-42.55c-1.77,0-3.34,1.43-3.5,3.19l-2.56,28.4c-0.16,1.76,1.15,3.19,2.93,3.19h42.55 c1.77,0,3.34-1.43,3.5-3.19l2.56-28.4C666.02,121.04,664.71,119.61,662.94,119.61z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M713.63,115.35l-1.39-1.94c-0.51-0.71-1.32-1.14-2.17-1.14h-9.82c-0.85,0-1.61,0.43-2.04,1.14l-1.17,1.94 c-0.43,0.71-1.19,1.14-2.04,1.14h-5.86c-1.4,0-2.46,1.14-2.38,2.55l1.9,32.79c0.08,1.41,1.28,2.55,2.68,2.55h46.44 c1.4,0,2.46-1.14,2.38-2.55l-1.9-32.79c-0.08-1.41-1.28-2.55-2.68-2.55H715.8C714.95,116.49,714.14,116.06,713.63,115.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M740.22,119.61h-42.55c-1.77,0-3.34,1.43-3.5,3.19l-2.56,28.4c-0.16,1.76,1.15,3.19,2.93,3.19h42.55 c1.77,0,3.34-1.43,3.5-3.19l2.56-28.4C743.3,121.04,741.99,119.61,740.22,119.61z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M790.91,115.35l-1.39-1.94c-0.51-0.71-1.32-1.14-2.17-1.14h-9.82c-0.85,0-1.61,0.43-2.04,1.14l-1.17,1.94 c-0.43,0.71-1.19,1.14-2.04,1.14h-5.86c-1.4,0-2.46,1.14-2.38,2.55l1.9,32.79c0.08,1.41,1.28,2.55,2.68,2.55h46.44 c1.4,0,2.46-1.14,2.38-2.55l-1.9-32.79c-0.08-1.41-1.28-2.55-2.68-2.55h-19.78C792.23,116.49,791.42,116.06,790.91,115.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M817.5,119.61h-42.55c-1.77,0-3.34,1.43-3.5,3.19l-2.56,28.4c-0.16,1.76,1.15,3.19,2.93,3.19h42.55 c1.77,0,3.34-1.43,3.5-3.19l2.56-28.4C820.58,121.04,819.27,119.61,817.5,119.61z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 167.95,
    y: 136.05,
    className: "st1",
    width: 281.55,
    height: 179.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.95,
    y: 136.05,
    className: "st5",
    width: 281.55,
    height: 12.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M445.31,142.11c0,2.02-1.64,3.66-3.66,3.66c-2.02,0-3.66-1.64-3.66-3.66c0-2.02,1.64-3.66,3.66-3.66 C443.67,138.46,445.31,140.1,445.31,142.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M433.16,142.11c0,2.02-1.64,3.66-3.66,3.66s-3.66-1.64-3.66-3.66c0-2.02,1.64-3.66,3.66-3.66 S433.16,140.1,433.16,142.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M421.01,142.11c0,2.02-1.64,3.66-3.66,3.66s-3.66-1.64-3.66-3.66c0-2.02,1.64-3.66,3.66-3.66 S421.01,140.1,421.01,142.11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M218.86,169.22l-1.73-2.41c-0.63-0.88-1.65-1.41-2.7-1.41h-12.21c-1.05,0-2,0.53-2.54,1.41l-1.45,2.41 c-0.53,0.88-1.48,1.41-2.54,1.41h-7.29c-1.74,0-3.06,1.42-2.96,3.17l2.36,40.79c0.1,1.75,1.59,3.17,3.33,3.17h57.76 c1.74,0,3.06-1.42,2.96-3.17l-2.36-40.79c-0.1-1.75-1.59-3.17-3.33-3.17h-24.6C220.51,170.63,219.5,170.1,218.86,169.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M251.94,174.52h-52.92c-2.21,0-4.15,1.77-4.35,3.96l-3.18,35.32c-0.2,2.19,1.43,3.96,3.64,3.96h52.92 c2.21,0,4.15-1.77,4.35-3.96l3.18-35.32C255.77,176.29,254.14,174.52,251.94,174.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M306.98,169.22l-1.73-2.41c-0.63-0.88-1.65-1.41-2.7-1.41h-12.21c-1.05,0-2,0.53-2.54,1.41l-1.45,2.41 c-0.53,0.88-1.48,1.41-2.54,1.41h-7.29c-1.74,0-3.06,1.42-2.96,3.17l2.36,40.79c0.1,1.75,1.59,3.17,3.33,3.17h57.76 c1.74,0,3.06-1.42,2.96-3.17l-2.36-40.79c-0.1-1.75-1.59-3.17-3.33-3.17h-24.6C308.63,170.63,307.62,170.1,306.98,169.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M340.05,174.52h-52.92c-2.21,0-4.15,1.77-4.35,3.96l-3.18,35.32c-0.2,2.19,1.43,3.96,3.64,3.96h52.92 c2.21,0,4.15-1.77,4.35-3.96l3.18-35.32C343.89,176.29,342.26,174.52,340.05,174.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M395.1,169.22l-1.73-2.41c-0.63-0.88-1.65-1.41-2.7-1.41h-12.21c-1.05,0-2,0.53-2.54,1.41l-1.45,2.41 c-0.53,0.88-1.48,1.41-2.54,1.41h-7.29c-1.74,0-3.06,1.42-2.96,3.17l2.36,40.79c0.1,1.75,1.59,3.17,3.33,3.17h57.76 c1.74,0,3.06-1.42,2.96-3.17l-2.36-40.79c-0.1-1.75-1.59-3.17-3.33-3.17h-24.6C396.75,170.63,395.73,170.1,395.1,169.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M428.17,174.52h-52.92c-2.21,0-4.15,1.77-4.35,3.96l-3.18,35.32c-0.2,2.19,1.43,3.96,3.64,3.96h52.92 c2.21,0,4.15-1.77,4.35-3.96l3.18-35.32C432.01,176.29,430.38,174.52,428.17,174.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M218.86,243.85l-1.73-2.41c-0.63-0.88-1.65-1.41-2.7-1.41h-12.21c-1.05,0-2,0.53-2.54,1.41l-1.45,2.41 c-0.53,0.88-1.48,1.41-2.54,1.41h-7.29c-1.74,0-3.06,1.42-2.96,3.17l2.36,40.79c0.1,1.75,1.59,3.17,3.33,3.17h57.76 c1.74,0,3.06-1.42,2.96-3.17l-2.36-40.79c-0.1-1.75-1.59-3.17-3.33-3.17h-24.6C220.51,245.26,219.5,244.73,218.86,243.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M251.94,249.15h-52.92c-2.21,0-4.15,1.77-4.35,3.96l-3.18,35.32c-0.2,2.19,1.43,3.96,3.64,3.96h52.92 c2.21,0,4.15-1.77,4.35-3.96l3.18-35.32C255.77,250.92,254.14,249.15,251.94,249.15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M306.98,243.85l-1.73-2.41c-0.63-0.88-1.65-1.41-2.7-1.41h-12.21c-1.05,0-2,0.53-2.54,1.41l-1.45,2.41 c-0.53,0.88-1.48,1.41-2.54,1.41h-7.29c-1.74,0-3.06,1.42-2.96,3.17l2.36,40.79c0.1,1.75,1.59,3.17,3.33,3.17h57.76 c1.74,0,3.06-1.42,2.96-3.17l-2.36-40.79c-0.1-1.75-1.59-3.17-3.33-3.17h-24.6C308.63,245.26,307.62,244.73,306.98,243.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M340.05,249.15h-52.92c-2.21,0-4.15,1.77-4.35,3.96l-3.18,35.32c-0.2,2.19,1.43,3.96,3.64,3.96h52.92 c2.21,0,4.15-1.77,4.35-3.96l3.18-35.32C343.89,250.92,342.26,249.15,340.05,249.15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M395.1,243.85l-1.73-2.41c-0.63-0.88-1.65-1.41-2.7-1.41h-12.21c-1.05,0-2,0.53-2.54,1.41l-1.45,2.41 c-0.53,0.88-1.48,1.41-2.54,1.41h-7.29c-1.74,0-3.06,1.42-2.96,3.17l2.36,40.79c0.1,1.75,1.59,3.17,3.33,3.17h57.76 c1.74,0,3.06-1.42,2.96-3.17l-2.36-40.79c-0.1-1.75-1.59-3.17-3.33-3.17h-24.6C396.75,245.26,395.73,244.73,395.1,243.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M428.17,249.15h-52.92c-2.21,0-4.15,1.77-4.35,3.96l-3.18,35.32c-0.2,2.19,1.43,3.96,3.64,3.96h52.92 c2.21,0,4.15-1.77,4.35-3.96l3.18-35.32C432.01,250.92,430.38,249.15,428.17,249.15z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M213.13,611.9c0.02-0.68,2.3-67.83,13.22-78.45c10.62-10.33,22.82-0.38,23.33,0.04l1.1-1.31 c-0.14-0.12-13.9-11.35-25.62,0.04c-11.41,11.1-13.65,76.83-13.74,79.62L213.13,611.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M212.19,625.1c0.08-0.8,7.46-80.61-21.68-114.06l-1.29,1.12c28.66,32.9,21.35,111.98,21.27,112.78 L212.19,625.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M213.27,616.65l1.71-0.11c-0.06-0.9-5.7-90.73,15.68-110.4l-1.16-1.26 C207.52,525.1,213.02,612.92,213.27,616.65z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M210.49,616.6l1.71-0.01c-0.02-2.47-0.71-60.68-17.24-70.15c-3.68-2.11-7.27-2.46-10.7-1.04 c-10,4.14-14.95,21.93-15.16,22.68l1.65,0.45c0.05-0.18,4.94-17.74,14.16-21.55c2.91-1.2,6-0.88,9.19,0.95 C209.8,556.91,210.48,616.01,210.49,616.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M216.93,616.65l1.71-0.1c-0.03-0.46-2.49-45.99,9.79-62.04c2.98-3.89,6.21-5.74,9.62-5.5 c8.05,0.56,14.8,12.35,14.87,12.46l1.49-0.84c-0.29-0.52-7.27-12.7-16.24-13.33c-4.01-0.29-7.75,1.79-11.1,6.17 C214.39,570.02,216.82,614.75,216.93,616.65z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M214.23,622.84c0.33-4.42,8.03-108.39-5.51-126.71l-1.37,1.02c13.17,17.81,5.26,124.49,5.18,125.56 L214.23,622.84z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M180.58,555.93c0,0,8.13,3,5.71,10.07c-2.42,7.07-28.11,18.71-28.11,18.71s-10.76-9.86-0.88-25.91 C167.18,542.77,180.36,550.87,180.58,555.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M215.9,542.47c0,0-8.65-0.36-9.14,7.1c-0.49,7.46,18.75,28.09,18.75,28.09s13.73-4.96,10.78-23.57 C233.34,535.47,218.05,537.88,215.9,542.47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.23,506.77c0,0-5.77-0.62-5.3-4.13c0.46-3.51,22.43-12.56,35.39,2.07c0,0-8.3,14.25-20.29,14.44 C221.03,519.33,223.23,506.77,223.23,506.77z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M212.48,498.24c0,0,5.22,2.53,6.69-0.7c1.46-3.23-12.39-22.52-31.12-16.96c0,0-0.5,16.48,9.58,22.99 C207.71,510.06,212.48,498.24,212.48,498.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M239.8,553.09c0,0-3.98-3.22,0.32-4.78c4.3-1.57,25.38-1.12,25.6,19.76c0,0-24.56,4.08-27.6-3.87 C235.08,556.24,239.8,553.09,239.8,553.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M189.72,506.25c0,0,3.98-3.21-0.32-4.78c-4.3-1.57-25.38-1.12-25.6,19.76c0,0,24.56,4.08,27.6-3.87 C194.44,509.4,189.72,506.25,189.72,506.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M202.7,523.07c0,0,0.35-3.91-2.8-2.38c-3.15,1.53-14.15,13.39-2.75,24.64c0,0,15.34-11.36,12.57-17.27 C206.95,522.15,202.7,523.07,202.7,523.07z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M243.36,528.64c0,0-2.38-3.12,1.11-3.51s19.11,3.78,15.47,19.38c0,0-19.03-1.43-19.85-7.91 C239.27,530.13,243.36,528.64,243.36,528.64z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "179.06,674.49 244.36,674.49 251.4,603 172.01,603  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.53,
    y: 595.11,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 423.4171 1205.9945)",
    className: "st11",
    width: 86.36,
    height: 15.78
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__359_",
    className: "st12",
    cx: 518,
    cy: 742.35,
    rx: 374.59,
    ry: 21.88
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M385.72,402.09c-0.18,7.12-1.47,16.15-7.06,21.19c-7.19,6.47-19.29,1.89-23.89-5.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M385.33,456.63l17.44,13.24c0,0,4.47,0.58,5.71,2.22c1.24,1.63,5.44,13.21,4.51,14.63 c-0.93,1.41-10.29,3.38-12,1.4c-1.71-1.98-3.9-12.51-3.72-13.59l-22.44-14.62L385.33,456.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M397.36,463.33l-6.09,10.41c0,0-31.9-19.96-37.13-23.12c-1.15-0.7-3.5-4-6.29-8.83 c-9.99-17.31-25.53-54.2-10.9-61.5c8-4,12.62,8.72,12.62,8.72s0.93,4.04,2.35,9.75c0.56,2.31,1.19,4.89,1.89,7.6 c0,0.04,0.02,0.06,0.02,0.08c3.22,12.64,7.4,27.82,9.39,29.61C366.65,439.18,397.36,463.33,397.36,463.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M347.85,441.78c-9.99-17.31-25.53-54.2-10.9-61.5c8-4,12.62,8.72,12.62,8.72s0.93,4.04,2.35,9.75 c0,0,1.03,2.98,1.89,7.6c0,0.04,0.02,0.06,0.02,0.08C355.43,415.36,356.35,430.3,347.85,441.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M302.59,418.02c0,0-10.4,3.55-27.85-4.39c-7.61-3.46-26.04-22.29-26.04-22.29s15.84-23.42,59.61-31.89 c0,0,28.75,3.74,50.44,50.57C358.74,410.02,337.49,421.58,302.59,418.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M337.16,445.12l13.79,17.01c0,0,4.2,1.63,5.02,3.51c0.82,1.88,2.15,14.13,0.91,15.28 c-1.24,1.15-10.8,0.84-11.99-1.49c-1.19-2.33-0.82-13.08-0.38-14.08l-18.32-19.53L337.16,445.12z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "335.39,707.98 323.67,710.05 318.86,694.07 314.48,679.41 327.99,674.69 331.91,692.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "331.98,692.67 318.92,694.39 314.51,679.57 328,674.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "257.16,713.38 245.26,713.38 243.31,696.62 241.54,681.32 255.66,678.98 256.46,697.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "256.46,697.33 243.31,696.76 241.54,681.39 255.66,679.01  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M273.29,736.95c-1.89-1.53-4.04-2.7-6.35-3.46l0,0c0,0-6.91-6.85-10.24-27.49l-9.05-2.36 c-3.15-0.76-6.43,0.52-8.23,3.21c-0.25,0.36-0.45,0.77-0.58,1.19c-0.47,2.21-0.79,4.45-0.97,6.71 c-0.91,6.98-0.13,22.66-0.13,22.66h1.63l0.65-14.23c0.24-4.83,3.94,0.84,5,6.04c1.06,5.2,3.31,10.74,13.9,11 C271.28,740.46,276.41,739.98,273.29,736.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M352.24,735.55c-1.89-1.53-4.04-2.7-6.35-3.46l0,0c0,0-6.91-6.85-10.24-27.49l-9.05-2.36 c-3.15-0.76-6.43,0.52-8.23,3.21c-0.25,0.36-0.45,0.77-0.58,1.19c-0.47,2.21-0.79,4.45-0.97,6.71 c-0.91,6.98-0.13,22.66-0.13,22.66h1.63l0.65-14.23c0.24-4.83,3.94,0.84,5,6.04c1.06,5.2,3.31,10.74,13.9,11 C350.23,739.07,355.36,738.58,352.24,735.55z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M333.08,683.37l-19.26,3.4c-19.44-48.43-33.26-88.85-43.03-122.4c-5.26-18.1-9.65-34.2-12.8-48.48 l0.59,52.72v118.76H239.6c-45.54-216.91-51.1-254.31,4.31-291.65l5.89-5.38c0,0,1.95,9.9,18.68,20.07 c14.03,8.53,31.66,9.09,31.66,9.09l-12.71,12.08l2.57,18.89l22.25,114.94L333.08,683.37z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M333.08,683.37l-19.26,3.4c-19.44-48.43-33.26-88.85-43.03-122.4c-5.26-18.1-9.65-34.2-12.8-48.48 l0.59,52.72v118.76H239.6c-45.54-216.91-51.1-254.31,4.31-291.65l5.89-5.38c0,0,1.95,9.9,18.68,20.07 c14.03,8.53,31.66,9.09,31.66,9.09l-12.71,12.08l2.57,18.89l22.25,114.94L333.08,683.37z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M270.79,564.37c-5.26-18.1-9.36-34.2-12.51-48.48c0,0,0.32-27.76,3.68-50.56 C261.96,465.33,270.3,530.54,270.79,564.37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.8,390.34c0,0,16.07,21.07,52.79,27.68l-6.89,5.71c0,0-29.58-2.03-51.79-28.01L249.8,390.34z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M291.02,416.68c-0.26-0.71-0.87-1.3-1.67-1.63l-5.78-2.36c-1.5-0.61-3.25-0.19-4.08,0.99l-2.04,2.89 c-0.44,0.63-0.55,1.4-0.28,2.1c0.24,0.63,0.75,1.18,1.43,1.52c0.08,0.04,0.16,0.08,0.25,0.11l5.79,2.35 c1.49,0.61,3.24,0.18,4.07-0.99l2.03-2.88C291.18,418.16,291.28,417.39,291.02,416.68z M285.33,421.44l-5.79-2.35 c-0.4-0.16-0.68-0.44-0.81-0.79c-0.13-0.35-0.08-0.71,0.14-1.02l2.04-2.89c0.4-0.57,1.25-0.78,1.98-0.48l5.78,2.36 c0.04,0.02,0.08,0.03,0.12,0.05c0.33,0.17,0.57,0.42,0.69,0.73c0.13,0.35,0.08,0.71-0.14,1.02l-0.31,0.44 c-0.06-0.05-0.12-0.1-0.2-0.13l-1.61-0.67c-0.54-0.22-1.19-0.05-1.44,0.4c-0.26,0.44-0.03,0.99,0.51,1.21l1.61,0.67 c0.03,0.01,0.06,0.01,0.08,0.02l-0.67,0.95C286.9,421.53,286.05,421.74,285.33,421.44z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M389.44,354.7c2.61,3.23,6.89,9.96,5.51,21.23c-1.38,11.27-4.92,27.63-2.95,37.85 c1.97,10.22-3.35,20.25-8.17,20.45c0,0,5.92-4.26,5.67-10.5c-0.25-6.23-1.83-16.69-1.83-16.69s-0.83,10.55-7.79,14.54 c-6.97,3.99-24.09-2.51-29.6-18.64c-5.51-16.14-14.32-20.53-18.72-27.52c-4.4-6.99-4.15-13.6,6.5-19.8 C348.7,349.41,380.3,343.35,389.44,354.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M346.16,402.09l-5.03-2.67c-0.02-0.02-0.02-0.02-0.02-0.02c-3.84,5.89-18.98,0-18.98,0 c-6.69-11.82,3.56-28.16,3.56-28.16c2.91,5.35,12.89,5.35,15.02,5.27c0.26,0,0.4,0,0.4,0L346.16,402.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M346.16,402.09l-5.03-2.67c-0.02-0.02-0.02-0.02-0.02-0.02s-5.85-2.37-9.53-2.11c0,0-0.8-12.2,7.6-19.8 c0.48-0.44,0.99-0.76,1.53-0.98c0.26,0,0.4,0,0.4,0L346.16,402.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M379.18,350.78c0,0,18.33,8.88,12.58,24.53c-5.75,15.65-21.2,16.4-21.2,16.4L379.18,350.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M372.92,357.05c13,7.48,13.18,16.84,6.42,30.79c-8.44,17.42-18.99,27.18-33.19,14.26 C326.88,384.54,351.33,344.63,372.92,357.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M371.36,382.28c0,0-0.15,4.43,0.68,7.57c0,0-2.13,1.13-4.27-0.5L371.36,382.28z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M364.01,376.64c-0.59,1.08-1.65,1.64-2.37,1.25c-0.72-0.39-0.83-1.59-0.24-2.67 c0.59-1.08,1.65-1.64,2.37-1.25C364.5,374.36,364.6,375.55,364.01,376.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M363.45,373.85l2.86,0.36C366.3,374.21,364.05,375.55,363.45,373.85z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M377.59,383.74c-0.59,1.08-1.65,1.64-2.37,1.25c-0.72-0.39-0.83-1.59-0.24-2.67 c0.59-1.08,1.65-1.64,2.37-1.25C378.07,381.46,378.18,382.65,377.59,383.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M377.02,380.95l2.86,0.36C379.88,381.31,377.63,382.66,377.02,380.95z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M369.05,367.59c0,0-3.38-2.58-6.77-1.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M378.81,372.47c0,0,2.79,0.47,4.57,4.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M346.11,370.78c0,0,12.22-7.18,16.04-15.96c0,0,31.81,4.3,18.04,31.17c0,0,15.87-21.77-6.17-35.14 c-22.01-13.35-40.79,13.13-34.86,29.51C339.17,380.37,338.51,375.3,346.11,370.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M381.96,351.2c0,0,7.49,4.06,8.64,8.69c1.15,4.62-27.74,10.46-39.91,5.32c0,0-10.77,7.62-11.52,15.16 c0,0-10.26-10.22,1.31-29.28C352.05,332.02,376.27,337.81,381.96,351.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M346.65,374.75c1.12-2.14,1-6.93-3.14-8.74c-4.28-1.88-10.96,5.29-2.08,13.04 C342.7,380.16,344.32,379.22,346.65,374.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M390.5,361.18c0,0-13.88,13.15-31.9,8.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M358.6,386.61c0,0-1.08,4.35,4.11,8.71"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M329.59,417.93c-7.7,0.9-16.75,1.15-27,0.1c0,0-1.85,0.64-5.31,0.76c-0.74-3.14-1.33-6.82-1.51-10.76 c-0.52-11.9,2.11-33.03,4.99-36.77c2.89-3.74,16.16,1.75,17.73,11.78c0,0,1.81,27.06,4.24,29.39 C324.07,413.71,327.14,416.08,329.59,417.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M308.3,361.18c-20.71,3.01-4.33,66.36,0,70.69c4.33,4.33,30.56,31.29,30.56,31.29l8.4-8.66 c0,0-24.08-30.76-26.69-34.63c-2.61-3.87-2.08-48.94-2.08-48.94S318.99,359.62,308.3,361.18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 471.92,
    y: 174.89,
    className: "st21",
    width: 372.3,
    height: 566.84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.92,
    y: 174.89,
    className: "st22",
    width: 372.3,
    height: 566.84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 699.63,
    y: 174.89,
    className: "st15",
    width: 144.59,
    height: 566.84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 482.82,
    y: 478.18,
    className: "st15",
    width: 204.61,
    height: 204.61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.75,
    y: 478.18,
    className: "st15",
    width: 51.69,
    height: 204.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "482.82,478.18 542.61,537.97 635.75,537.97 687.44,537.97 687.44,478.18  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 482.82,
    y: 256.24,
    className: "st15",
    width: 204.61,
    height: 204.61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 482.82,
    y: 256.24,
    className: "st21",
    width: 198.78,
    height: 204.61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 482.82,
    y: 256.24,
    className: "st23",
    width: 198.78,
    height: 204.61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 538.42,
    y: 280.72,
    className: "st19",
    width: 71.08,
    height: 18.34
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M640.47,371.74l-18.82-24.82h-3.74v16.85h-4.97l6.38,7.96c0.27,0.33,0.03,0.83-0.4,0.83h-53.6 c-0.96,0-1.86-0.45-2.44-1.21l-5.75-7.58h-21.48l15.51,19.36c0.58,0.72,1.46,1.15,2.39,1.15h84.47 c1.69,0,3.06-1.37,3.06-3.06v-7.63C641.1,372.92,640.88,372.27,640.47,371.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M620.57,366.32H517.04c-0.86,0-1.55-0.69-1.55-1.55v-17.54c0-0.86,0.69-1.55,1.55-1.55h103.52 c0.86,0,1.55,0.69,1.55,1.55v17.54C622.12,365.62,621.42,366.32,620.57,366.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M596.49,366.32h-79.45c-0.86,0-1.55-0.69-1.55-1.55v-17.54c0-0.86,0.69-1.55,1.55-1.55h79.45 c0.86,0,1.55,0.69,1.55,1.55v17.54C598.04,365.62,597.35,366.32,596.49,366.32z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M544.18,291.86c3.86-1.26,7.22-3.99,9.25-7.51c-2.84,1.93-4.64,5.32-4.65,8.75 c3.43,0.54,4.98-4.71,8.33-5.63c-0.38,1.7-0.76,3.39-1.15,5.09c1.74,0.21,3.55-0.42,4.8-1.64c2.61,0.08,5.24-0.94,7.12-2.76 c-0.6-1.1-2.1-1.62-3.25-1.12c3.64,0.34,7.28,0.68,10.92,1.03c-1.19-0.52-2.67,0.78-2.39,2.04c0.28,1.26,2.08,1.83,3.08,1.02 c0.32-0.26,0.55-0.61,0.67-1.01c0.1-0.34,0.11-0.71,0.31-0.99c0.38-0.53,1.17-0.48,1.81-0.38c6.56,1.02,13.26,1.19,19.86,0.51 "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "687.44,575.78 699.63,590.94 699.63,741.72 516.98,741.72 471.92,692.06  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M671.81,500.6H562.3l-1.12-7.06c-0.26-1.62-1.6-2.75-3.27-2.75h-30.22c-1.67,0-3.26,1.13-3.87,2.75 l-2.66,7.06h-24.59c-4.68,0-8.88,3.81-9.4,8.51L472.2,646.29c-0.51,4.7,2.86,8.51,7.54,8.51h175.24c4.68,0,8.88-3.81,9.4-8.51 l14.97-137.18C679.86,504.41,676.49,500.6,671.81,500.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M671.81,500.6H562.3l-1.12-7.06c-0.26-1.62-1.6-2.75-3.27-2.75h-30.22c-1.67,0-3.26,1.13-3.87,2.75 l-2.66,7.06h-24.59c-4.68,0-8.88,3.81-9.4,8.51L472.2,646.29c-0.51,4.7,2.86,8.51,7.54,8.51h175.24c4.68,0,8.88-3.81,9.4-8.51 l14.97-137.18C679.86,504.41,676.49,500.6,671.81,500.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "472.49,649.55 478.35,506.91 667.81,506.91 658.37,646.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "472.49,649.55 478.35,506.91 667.81,506.91 658.37,646.41  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M652.54,655.34H477.3c-4.68,0-8.44-3.55-8.4-7.94l1.05-127.94c0.04-4.38,3.86-7.94,8.53-7.94h175.24 c4.68,0,8.44,3.55,8.4,7.94l-1.05,127.94C661.04,651.78,657.22,655.34,652.54,655.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M652.54,655.34H477.3c-4.68,0-8.44-3.55-8.4-7.94l1.05-127.94c0.04-4.38,3.86-7.94,8.53-7.94h175.24 c4.68,0,8.44,3.55,8.4,7.94l-1.05,127.94C661.04,651.78,657.22,655.34,652.54,655.34z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "582.21,511.52 585.77,641.32 489.89,641.32 484.33,511.52  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M553.9,496.25H444.39l-1.89-7.03c-0.43-1.62-1.9-2.74-3.57-2.74h-30.22c-1.67,0-3.14,1.12-3.57,2.74 l-1.89,7.03h-24.59c-4.68,0-8.47,3.79-8.47,8.47v136.48c0,4.68,3.79,8.47,8.47,8.47H553.9c4.68,0,8.47-3.79,8.47-8.47V504.72 C562.37,500.04,558.58,496.25,553.9,496.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M553.9,496.25H444.39l-1.89-7.03c-0.43-1.62-1.9-2.74-3.57-2.74h-30.22c-1.67,0-3.14,1.12-3.57,2.74 l-1.89,7.03h-24.59c-4.68,0-8.47,3.79-8.47,8.47v136.48c0,4.68,3.79,8.47,8.47,8.47H553.9c4.68,0,8.47-3.79,8.47-8.47V504.72 C562.37,500.04,558.58,496.25,553.9,496.25z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "370.84,644.43 361.14,502.53 550.6,502.53 556.39,641.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "370.84,644.43 361.14,502.53 550.6,502.53 556.39,641.32  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M551.53,650.19H376.29c-4.68,0-8.83-3.54-9.27-7.9L354.1,515.02c-0.44-4.36,2.99-7.9,7.67-7.9H537 c4.68,0,8.83,3.54,9.27,7.9l12.92,127.28C559.64,646.66,556.2,650.19,551.53,650.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "505.87,603.3 687.44,575.78 687.44,674.63 519.16,706.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "505.87,603.3 687.44,575.78 687.44,674.63 519.16,706.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "505.87,603.3 508.43,606.1 687.44,578.56 687.44,575.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "535.67,598.78 543.86,600.65 550.6,700.83 519.16,706.85 505.87,603.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "535.67,719.86 331.05,719.86 318.2,518.31 522.81,518.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "535.67,719.86 331.05,719.86 318.2,518.31 522.81,518.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "535.66,719.87 529.84,719.87 516.98,518.3 522.81,518.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "447.57,560.49 376.49,560.49 375.33,542.42 446.42,542.42  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M483.11,632.08l-20.38-24.45h-3.74l1.06,16.59h-4.97l6.88,7.85c0.29,0.33,0.08,0.81-0.34,0.81h-53.6 c-0.96,0-1.89-0.44-2.51-1.19l-6.23-7.47H377.8l16.73,19.07c0.63,0.71,1.53,1.13,2.46,1.13h84.47 c1.69,0,2.97-1.35,2.87-3.01l-0.48-7.52C483.8,633.24,483.54,632.61,483.11,632.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M461.41,626.74H360.78c-1.65,0-3.08-1.32-3.18-2.95l-0.92-14.43c-0.1-1.63,1.15-2.95,2.81-2.95h100.63 c1.65,0,3.08,1.32,3.18,2.95l0.92,14.43C464.32,625.42,463.06,626.74,461.41,626.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M437.34,626.74h-76.56c-1.65,0-3.08-1.32-3.18-2.95l-0.92-14.43c-0.1-1.63,1.15-2.95,2.81-2.95h76.56 c1.65,0,3.08,1.32,3.18,2.95l0.92,14.43C440.25,625.42,438.99,626.74,437.34,626.74z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M382.47,551.47c2.82,1.15,5.54-0.25,7.48-2.25c0.07,1.52-0.45,3.49-0.36,5.23 c1.36-1.37,2.5-2.98,3.29-4.73c-1.42,3.15,2.32,3.92,4.53,2.82c1.43-0.71,2.58-2.16,2.57-3.76c0-0.52-0.21-1.13-0.72-1.23 c-0.47-0.09-0.89,0.32-1.15,0.73c-0.88,1.37-1.98,5.16,0.23,5.63c2.02,0.43,4.68-3.19,5.27-4.69 c-1.19,0.56-1.94,1.91-1.8,3.21c2.23-0.11,5.3,0.44,5.45-2.58c-0.19,3.98,3.6,2.64,4.98,0.01c-0.45,1.41,1.65,2.13,3.13,2.1 c6.57-0.15,13.15-0.29,19.72-0.44"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 219.91,
    y: 260.08,
    transform: "matrix(0.6871 0.7265 -0.7265 0.6871 267.1871 -75.8181)",
    className: "st6",
    width: 3.43,
    height: 24.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st32",
    cx: 222.13,
    cy: 272.16,
    r: 11.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 219.91,
    y: 184.46,
    transform: "matrix(0.6871 0.7265 -0.7265 0.6871 212.2444 -99.4787)",
    className: "st6",
    width: 3.43,
    height: 24.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st32",
    cx: 222.13,
    cy: 196.54,
    r: 11.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 309.71,
    y: 260.08,
    transform: "matrix(0.6871 0.7265 -0.7265 0.6871 295.2841 -141.0626)",
    className: "st6",
    width: 3.43,
    height: 24.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st32",
    cx: 311.93,
    cy: 272.16,
    r: 11.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 309.71,
    y: 184.46,
    transform: "matrix(0.6871 0.7265 -0.7265 0.6871 240.3414 -164.7232)",
    className: "st6",
    width: 3.43,
    height: 24.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st32",
    cx: 311.93,
    cy: 196.54,
    r: 11.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 396.68,
    y: 184.46,
    transform: "matrix(0.6871 0.7265 -0.7265 0.6871 267.5511 -227.9074)",
    className: "st6",
    width: 3.43,
    height: 24.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st32",
    cx: 398.9,
    cy: 196.54,
    r: 11.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 397.62,
    y: 260.08,
    transform: "matrix(0.6871 0.7265 -0.7265 0.6871 322.7896 -204.9335)",
    className: "st6",
    width: 3.43,
    height: 24.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st32",
    cx: 399.84,
    cy: 272.16,
    r: 11.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 637.72,
    y: 126.8,
    transform: "matrix(0.6871 0.7265 -0.7265 0.6871 301.0754 -421.0786)",
    className: "st6",
    width: 3.43,
    height: 24.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st32",
    cx: 639.94,
    cy: 138.87,
    r: 11.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 715.23,
    y: 126.8,
    transform: "matrix(0.6871 0.7265 -0.7265 0.6871 325.3275 -477.3949)",
    className: "st6",
    width: 3.43,
    height: 24.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st32",
    cx: 717.45,
    cy: 138.87,
    r: 11.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 792.75,
    y: 126.8,
    transform: "matrix(0.6871 0.7265 -0.7265 0.6871 349.5797 -533.7112)",
    className: "st6",
    width: 3.43,
    height: 24.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st32",
    cx: 794.97,
    cy: 138.87,
    r: 11.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M660.05,221.94c-0.33-1.85-1.8-3.2-3.68-3.36c-2.33-0.21-4.38,1.65-4.38,3.99c0,0.7,0,1.4,0,2.1 c0,0.72,0,1.45,0,2.17c0,1.21,0.89,2.09,2.1,2.1c1.31,0,2.62,0,3.93,0c1.2,0,2.1-0.9,2.1-2.1c0-1.4,0-2.81,0-4.21 C660.1,222.39,660.09,222.16,660.05,221.94z M659.2,225.13c-0.3-0.01-0.3,0-0.33-0.28c-0.13-1.41-1.4-2.54-2.84-2.49 c-1.38-0.06-2.73,1.02-2.85,2.56c-0.01,0.17-0.06,0.22-0.23,0.21c-0.28-0.02-0.26,0.05-0.25-0.27c0.06-1.34,1.13-2.57,2.5-2.9 c1.8-0.43,3.56,0.58,4.05,2.32c0.06,0.22,0.1,0.44,0.11,0.67C659.37,225.09,659.34,225.13,659.2,225.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M654.7,218.28c0.1-0.03,0.15-0.07,0.16-0.19c0.02-0.59,0.47-1.09,1.03-1.13c0.64-0.05,1.19,0.32,1.27,0.95 c0.04,0.32,0.2,0.39,0.44,0.46c0.09,0.02,0.12,0.01,0.12-0.08c0.07-1.02-0.7-1.85-1.71-1.85c-0.88,0-1.64,0.7-1.69,1.56 C654.31,218.41,654.31,218.4,654.7,218.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M660.69,227.39c0.56,0.07,0.92-0.23,0.92-0.8c0-0.64,0-1.27,0-1.91c0-0.43-0.19-0.67-0.6-0.8 c-0.08-0.02-0.16-0.04-0.23-0.07c-0.14-0.06-0.19-0.04-0.19,0.13c0.01,0.54,0,1.08,0,1.62c0,0.55,0,1.11,0,1.66 C660.59,227.3,660.57,227.37,660.69,227.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M651.48,224.18c0-0.44,0-0.44-0.42-0.31c-0.45,0.14-0.62,0.37-0.62,0.84c0,0.6,0,1.21,0,1.81 c0,0.62,0.25,0.86,0.87,0.86c0.13,0,0.17-0.04,0.17-0.17c-0.01-0.55,0-1.09,0-1.64C651.48,225.12,651.48,224.65,651.48,224.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M664.08,219.93c-0.44-1-1.07-1.89-1.86-2.66c-0.8-0.77-1.73-1.37-2.76-1.79 c-1.07-0.44-2.21-0.66-3.38-0.66s-2.31,0.22-3.38,0.66c-0.24,0.1-0.47,0.2-0.7,0.32c-0.01-0.05-0.02-0.1-0.03-0.15 c-0.11-0.59-0.44-1.1-0.89-1.46c-0.46-0.37-0.99-0.54-1.52-0.53c-0.01,0-0.01,0-0.02,0c-1.37,0-2.47,1.1-2.47,2.45 c0,1.13,0.77,2.08,1.82,2.37c-0.32,0.46-0.6,0.94-0.83,1.45c-0.45,1.03-0.68,2.13-0.68,3.26c0,1.13,0.23,2.22,0.68,3.26 c0.44,1,1.07,1.89,1.86,2.66c0.8,0.77,1.73,1.37,2.76,1.79c1.07,0.44,2.21,0.66,3.38,0.66s2.31-0.22,3.38-0.66 c1.04-0.42,1.97-1.02,2.76-1.79c0.8-0.77,1.43-1.66,1.86-2.66c0.45-1.03,0.68-2.13,0.68-3.26 C664.76,222.06,664.53,220.96,664.08,219.93z M660.59,225.57c0-0.54,0.01-1.08,0-1.62c0-0.17,0.05-0.19,0.19-0.13 c0.07,0.03,0.16,0.05,0.23,0.07c0.41,0.13,0.6,0.37,0.6,0.8c0,0.64,0,1.27,0,1.91c0,0.57-0.36,0.86-0.92,0.8 c-0.12-0.01-0.1-0.09-0.1-0.16C660.59,226.68,660.59,226.12,660.59,225.57z M660.1,226.83c0,1.21-0.89,2.1-2.1,2.1 c-1.31,0-2.62,0-3.93,0c-1.21,0-2.1-0.89-2.1-2.1c0-0.72,0-1.45,0-2.17c0-0.7,0-1.4,0-2.1c0.01-2.34,2.05-4.2,4.38-3.99 c1.89,0.17,3.36,1.51,3.68,3.36c0.04,0.22,0.06,0.45,0.06,0.68C660.1,224.02,660.1,225.42,660.1,226.83z M654.33,217.99 c0.05-0.86,0.81-1.56,1.69-1.56c1.01,0,1.78,0.83,1.71,1.85c-0.01,0.1-0.03,0.11-0.12,0.08c-0.24-0.06-0.4-0.14-0.44-0.46 c-0.08-0.63-0.63-1-1.27-0.95c-0.56,0.05-1.02,0.54-1.03,1.13c0,0.12-0.05,0.16-0.16,0.19 C654.31,218.4,654.31,218.41,654.33,217.99z M651.48,227.22c0,0.13-0.04,0.17-0.17,0.17c-0.62,0-0.87-0.24-0.87-0.86 c0-0.6,0-1.21,0-1.81c0-0.48,0.17-0.71,0.62-0.84c0.42-0.13,0.42-0.13,0.42,0.31c0,0.47,0,0.93,0,1.4 C651.48,226.13,651.48,226.67,651.48,227.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M659.25,224.29c-0.49-1.75-2.25-2.75-4.05-2.32c-1.37,0.33-2.44,1.56-2.5,2.9 c-0.02,0.32-0.03,0.25,0.25,0.27c0.17,0.01,0.22-0.04,0.23-0.21c0.12-1.54,1.47-2.62,2.85-2.56c1.44-0.05,2.71,1.08,2.84,2.49 c0.03,0.29,0.04,0.28,0.33,0.28c0.14,0,0.17-0.04,0.16-0.17C659.35,224.73,659.32,224.51,659.25,224.29z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M484.53,223.09c0-4.94,3.51-8.25,8.8-8.25c2.13,0,4.09,0.73,5.59,1.9l-2.81,3.36 c-0.67-0.61-1.52-1.02-2.69-1.02c-2.25,0-3.71,1.61-3.71,4.01s1.43,4.01,3.71,4.01c1.37,0,2.43-0.38,3.22-1.29l2.81,3.3 c-1.55,1.52-3.77,2.25-6.23,2.25C488.01,231.36,484.53,228.06,484.53,223.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M517.57,221.07v10h-4.97v-9.24c0-1.67-1.2-2.75-3.01-2.75c-1.84,0-3.04,1.08-3.04,2.75v9.24h-4.97v-22.81 h4.97v8.54c1.23-1.32,2.98-1.96,4.8-1.96C515.08,214.84,517.57,217.33,517.57,221.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M537.48,215.14v15.94h-4.77l-0.09-1.96c-1.08,1.43-2.69,2.25-4.85,2.25c-4.21,0-7.6-3.25-7.6-8.19 c0-4.97,3.39-8.33,7.6-8.33c2.16,0,3.77,0.82,4.85,2.28l0.09-1.99H537.48z M532.51,223.09c0-2.37-1.43-4.01-3.6-4.01 c-2.16,0-3.6,1.64-3.6,4.04c0,2.37,1.43,3.98,3.6,3.98C531.08,227.1,532.51,225.52,532.51,223.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M566.49,221.07v10h-4.97v-9.24c0-1.67-1.02-2.75-2.6-2.75c-1.58,0-2.63,1.08-2.63,2.75v9.24h-4.97v-9.24 c0-1.67-1.02-2.75-2.6-2.75c-1.58,0-2.63,1.08-2.63,2.75v9.24h-4.97v-15.94h4.8l0.06,1.64c1.14-1.32,2.78-1.93,4.5-1.93 c1.93,0,3.51,0.76,4.53,2.08c1.23-1.4,3.04-2.08,4.97-2.08C563.86,214.84,566.49,217.33,566.49,221.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M587.28,223.18c0,4.94-3.39,8.19-7.6,8.19c-2.13,0-3.74-0.82-4.82-2.25l-0.09,1.96h-4.8v-22.81h4.97v8.74 c1.08-1.37,2.66-2.16,4.74-2.16C583.89,214.84,587.28,218.21,587.28,223.18z M582.16,223.12c0-2.4-1.46-4.04-3.6-4.04 c-2.16,0-3.63,1.64-3.63,4.01c0,2.43,1.46,4.01,3.63,4.01C580.7,227.1,582.16,225.49,582.16,223.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M606.55,215.14v15.94h-4.77l-0.09-1.96c-1.08,1.43-2.69,2.25-4.85,2.25c-4.21,0-7.6-3.25-7.6-8.19 c0-4.97,3.39-8.33,7.6-8.33c2.16,0,3.77,0.82,4.85,2.28l0.09-1.99H606.55z M601.58,223.09c0-2.37-1.43-4.01-3.6-4.01 c-2.16,0-3.6,1.64-3.6,4.04c0,2.37,1.43,3.98,3.6,3.98C600.14,227.1,601.58,225.52,601.58,223.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M619.38,226.6v3.98c-1.26,0.56-2.78,0.79-4.15,0.79c-3.1,0-5.2-2.13-5.2-5.32v-15.59H615v4.68h4.15v4.06 H615v5.79c0,1.26,0.76,2.11,1.84,2.11C617.69,227.1,618.54,226.95,619.38,226.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M621.64,210.43c0-1.67,1.23-2.87,2.9-2.87c1.67,0,2.87,1.2,2.87,2.87c0,1.67-1.2,2.87-2.87,2.87 C622.86,213.29,621.64,212.1,621.64,210.43z M622.02,215.14h4.97v15.94h-4.97V215.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M629.79,223.09c0-4.94,3.51-8.25,8.8-8.25c2.13,0,4.09,0.73,5.59,1.9l-2.81,3.36 c-0.67-0.61-1.52-1.02-2.69-1.02c-2.25,0-3.71,1.61-3.71,4.01s1.43,4.01,3.71,4.01c1.37,0,2.43-0.38,3.22-1.29l2.81,3.3 c-1.55,1.52-3.77,2.25-6.23,2.25C633.27,231.36,629.79,228.06,629.79,223.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M684.37,221.36v10h-4.97v-9.24c0-1.67-1.2-2.75-3.01-2.75c-1.84,0-3.04,1.08-3.04,2.75v9.24h-4.97v-15.94 h4.8l0.06,1.78c1.26-1.4,3.04-2.08,4.91-2.08C681.88,215.14,684.37,217.62,684.37,221.36z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoHayProyectos);
export default __webpack_public_path__ + "static/media/no_hay_proyectos.4c4cf707b4483070a65754dfe16b9dea.svg";
export { ForwardRef as ReactComponent };